import { atom } from "recoil";
import { LoginFlowPath, LoginFlowType } from "../types";
import { Login } from "@mui/icons-material";

export const LoginFlowState = atom<LoginFlowType>({
    key: 'LoginFlowState',
    default: {
        path: LoginFlowPath.Login,
    }
})